import mainTheme from './main';

export default {
  ...mainTheme
};